exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card--material-stats{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;position:relative}.v-card--material-stats .v-offset{display:inline-block;-webkit-box-flex:0;-ms-flex:0 1;flex:0 1;margin-top:0;margin-left:0;margin-right:auto;margin-bottom:0!important;max-width:auto;padding:0 16px}.v-card--material-stats .v-card{border-radius:4px;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.v-card--material-stats .v-card__text{display:inline-block;position:absolute;top:0;right:0;width:100%}.v-card--material-stats .v-card__actions{-webkit-box-flex:1;-ms-flex:1 0 100%;flex:1 0 100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a3247762","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/material/StatsCard.vue
// module id = 456
// module chunks = 0